import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const lineScale = keyframes`
  0% {
    transform: scaley(1.0);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1.0);
  }
`

const delay = (interval, count, index) => {
  return index * interval - interval * count
}

const lineScaleAnimation = ({ linesNb = 5 }) => {
  let animation = ''

  for (let i = 1; i <= linesNb; i++) {
    animation = css`
      ${animation}

      > div:nth-child(${i}) {
        animation: ${lineScale} 1s ${delay(0.1, linesNb, i)}s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
      }
    `
  }

  return animation
}

const Wrapper = styled.div`
  ${lineScaleAnimation}

  > div {
    display: inline-block;
    background-color: ${(props) => (props.white ? '#ffffff' : '#5d5c70')};
    width: 4px;
    height: 35px;
    border-radius: 2px;
    margin: 2px;
    animation-fill-mode: both;
  }
`

export const Loader = (props) => {
  return (
    <Wrapper {...props}>
      <div />

      <div />

      <div />

      <div />

      <div />
    </Wrapper>
  )
}
